import { Vehicle } from '../interfaces';
import { jsonIf } from '../utils/utils.network';

const VehicleOfferedAtAuction = 400031;

export const fetchAutoCheckData = async (vin: string): Promise<Vehicle.AutoCheckData> => {
  try {
    const response = await fetch(`${process.env.BASE_URL}/${process.env.V_PREFIX}/vehicles/vin/${vin}?vinVerified=true&api_key=${process.env.API_KEY}`, {
      headers: {
        authorization: `Basic ${process.env.ICO_TOKEN}`,
      },
      method: 'GET',
      mode: 'cors',
      redirect: 'follow',
    });
    return mapResponseToAutoCheckData(await jsonIf(response), vin);
  } catch (e) {
    console.log('autocheck data error', e);
    throw e;
  }
};

export default { fetchAutoCheckData };

const mapResponseToAutoCheckData = (autoCheckResponse, vin): Vehicle.AutoCheckData => {
  const {
    data: {
      autoCheckData: {
        isOriginalOwner,
        usedAsRentalCar,
        reportDate,
        hasAccidents,
        auctionAnnouncementWithin45Days,
        isAutoCheckEligible,
        floodDamage,
        frameDamage,
        miles,
        previouslyCanadian,
        salvage,
        titleBrand,
        notActualMileage,
      },
    },
    meta: { codes },
  } = autoCheckResponse;

  return {
    autoCheckFullReportLink: `${process.env.AUTO_CHECK_BASE_URL}&vin=${vin}`,
    hasSingleOwner: isOriginalOwner,
    hasPriorRentals: usedAsRentalCar,
    hasBeenToAuction: auctionAnnouncementWithin45Days,
    isAutocheckAuctionEligible: isAutoCheckEligible && !codes.includes(VehicleOfferedAtAuction),
    reportDate,
    hasAccidents,
    hasFloodDamage: floodDamage,
    hasFrameDamage: frameDamage,
    previouslyCanadian,
    isSalvage: salvage,
    verifiedMileage: miles,
    titleBrand,
    notActualMileage,
    autoCheckDataJSON: JSON.stringify(autoCheckResponse.data.autoCheckData),
    historyIcons: [],
  };
};
